import {
  faDirections,
  faMinus,
  faPen,
  faPlus,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";
import { Directions } from "./Directions";
import { SaveRoute } from "./SaveRoute";

export const Polyline = ({
  path,
  properties,
  onClose,
  isEdit,
  isView,
  setIsView,
  edit,
}: {
  path: any;
  properties: any;
  onClose: () => void;
  isEdit: boolean;
  isView: boolean;
  setIsView: (val: boolean) => void;
  edit: any;
}) => {
  const [instance, setInstance] = useState<google.maps.Polyline | null>(null);
  const [optimizePath, setOptimizePath] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const [directions, setDirections] = useState<any>([]);

  const map = useMap();

  useEffect(() => {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);

  useEffect(() => {
    instance?.setPath(path);
    if (isEdit && path.length > 1) {
      map?.setCenter(path[0]);
    }
  }, [instance, path]);

  useEffect(() => {
    const polyline = new google.maps.Polyline({
      strokeColor: "#2970FF",
      map,
    });

    setInstance(polyline);

    return () => {
      polyline.setMap(null);
    };
  }, []);

  return (
    <>
      <div className="absolute bottom-12 w-full flex gap-x-3 justify-center">
        {!isView && (
          <button
            onClick={() => setOptimizePath((state) => !state)}
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faDirections} />
            <span>
              {optimizePath
                ? " Disable Auto Optimize Route"
                : " Enable Auto Optimize Route"}
            </span>
          </button>
        )}
        {!isView && (
          <button
            onClick={() => setShowSave(true)}
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faPlus} />
            <span> Save Route</span>
          </button>
        )}
        <button
          onClick={onClose}
          className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
        >
          <FontAwesomeIcon icon={faMinus} />
          <span> Close</span>
        </button>
        {isView && (
          <button
            onClick={() => setIsView(false)}
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faPen} />
            <span> Edit Route</span>
          </button>
        )}
      </div>
      <Directions
        printPath={path}
        enable={optimizePath}
        directions={directions}
        setDirections={setDirections}
      />

      {showSave ? (
        <SaveRoute
          directions={[]}
          edit={edit}
          onRouteRemoved={console.log}
          path={path}
          properties={properties}
          onClose={() => setShowSave(false)}
        />
      ) : null}
    </>
  );
};
